export enum AccountStatusType { // type from inactive column
    Unknown = 0,
    Active = 1,
    Inactive = 2,
}